"use client";

import Link from "next/link";
import { useWishlist } from "@/lib/auth/use-wishlist";

export default function WishlistLink({ className = "" }: { className?: string }) {
  const { ids } = useWishlist();
  const count = ids.size;

  return (
    <Link
      href="/wishlist"
      aria-label={`Wishlist${count ? ` (${count})` : ""}`}
      className={`relative inline-flex items-center justify-center w-9 h-9 rounded-full hover:bg-ss-bg-soft ${className}`}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill={count ? "#e0245e" : "none"}
        stroke={count ? "#e0245e" : "currentColor"}
        strokeWidth="2"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.318 6.318a4.5 4.5 0 016.364 0L12 7.636l1.318-1.318a4.5 4.5 0 116.364 6.364L12 20.364l-7.682-7.682a4.5 4.5 0 010-6.364z"
        />
      </svg>
      {count > 0 && (
        <span className="absolute -top-1 -end-1 min-w-[18px] h-[18px] px-1 grid place-items-center text-[10.5px] font-bold rounded-full bg-ss-blue text-white">
          {count}
        </span>
      )}
    </Link>
  );
}
